import { createAction, props } from '@ngrx/store';
import type { PlatformAdminListItem } from './platform-admins.models';

export const loadAdmins = createAction('[PlatformAdmins] Load Admins');
export const loadAdminsSuccess = createAction(
  '[PlatformAdmins] Load Admins Success',
  props<{ admins: PlatformAdminListItem[] }>()
);
export const loadAdminsFailure = createAction(
  '[PlatformAdmins] Load Admins Failure',
  props<{ error: string }>()
);

export const addAdmin = createAction(
  '[PlatformAdmins] Add Admin',
  props<{ email: string; name: string; isSuper: boolean }>()
);
export const addAdminSuccess = createAction(
  '[PlatformAdmins] Add Admin Success',
  props<{ admin: PlatformAdminListItem }>()
);
export const addAdminFailure = createAction(
  '[PlatformAdmins] Add Admin Failure',
  props<{ error: string }>()
);

export const removeAdmin = createAction(
  '[PlatformAdmins] Remove Admin',
  props<{ id: number }>()
);
export const removeAdminSuccess = createAction(
  '[PlatformAdmins] Remove Admin Success',
  props<{ id: number }>()
);
export const removeAdminFailure = createAction(
  '[PlatformAdmins] Remove Admin Failure',
  props<{ error: string }>()
);
